import { Component, OnInit, AfterViewInit,
ElementRef,
ViewChild,
HostListener} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { NAV_MENU_ITEMS } from "./nav-menu.constant";
import { CommonDataService } from "@shared/services/common-data.service";
import { OnDestroy } from '@angular/core';


@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.scss"],
})
export class NavMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("modalContainer")
modalContainer!: ElementRef;
  menuItems: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    public router: Router,
    private commonDataService: CommonDataService
  ) { }

  ngOnInit() {
    this.menuItems = NAV_MENU_ITEMS;
    this.getFundDetails();
  }
  ngOnDestroy(): void { document.body.style.overflow = ''; }

//   ngAfterViewInit(): void {
//   setTimeout(() => {
//     this.modalContainer.nativeElement.focus();
//   });
// }
ngAfterViewInit(): void {

  document.body.style.overflow = 'hidden';

  setTimeout(() => {

    const firstFocusable =
      this.modalContainer.nativeElement.querySelector(
        'button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])'
      );

    if (firstFocusable) {
      firstFocusable.focus();
    } else {
      this.modalContainer.nativeElement.focus();
    }

  });
}

  closePop() {
  document.body.style.overflow = '';
  this.activeModal.close();
}

 navPage = () => {
  document.body.style.overflow = '';
  this.activeModal.close();
};

  getFundDetails() {
    const nfoMenu = this.menuItems.find((i) => i.displayName === "NFO");
    this.commonDataService.isNFOActive().subscribe({
      next: (isAccessible) => {
        nfoMenu.disabled = !isAccessible;
      },
      error: () => {
        nfoMenu.disabled = true;
      }
    });
  }

  accountStatements = () => {
    window.open("https://mfs.kfintech.com/investor/General/StatementsAndReports", "_blank");
  };

  @HostListener("keydown", ["$event"])
handleTab(event: KeyboardEvent): void {

  if (event.key !== "Tab") {
    return;
  }

  // const focusableElements =
  //   this.modalContainer.nativeElement.querySelectorAll(
  //     'button, a[href], [tabindex]:not([tabindex="-1"])'
  //   );
const focusableElements =
this.modalContainer.nativeElement.querySelectorAll(

'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'

);

  if (!focusableElements.length) {
    return;
  }

  const first = focusableElements[0] as HTMLElement;
  const last =
    focusableElements[focusableElements.length - 1] as HTMLElement;

  if (event.shiftKey) {

    if (document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }

  } else {

    if (document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }

  }

}
}
